"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Do not edit directly
 * Generated on Fri, 19 Apr 2024 10:08:41 GMT
 */
var _default = exports.default = {
  sky: {
    sys: {
      font: {
        heading: {
          "1": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 700;font-size: 32px;letter-spacing: 0;line-height: 40px;text-decoration: none;",
          "2": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 700;font-size: 28px;letter-spacing: 0;line-height: 36px;text-decoration: none;",
          "3": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 24px;letter-spacing: 0;line-height: 32px;text-decoration: none;",
          "4": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 20px;letter-spacing: 0;line-height: 24px;text-decoration: none;"
        },
        subheading: {
          "1": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
          "2": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
        },
        body: {
          "1": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
          "2": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
        },
        detail: {
          "1": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 12px;letter-spacing: 0.3px;line-height: 16px;text-decoration: none;",
          "2": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 10px;letter-spacing: 0.3px;line-height: 14px;text-decoration: none;"
        },
        label: {
          "1": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;"
        },
        link: {
          "1": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: underline;",
          "2": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: underline;"
        },
        tags: {
          "1": "font-family: DM Mono;font-weight: 400;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
          "2": "font-family: DM Mono;font-weight: 400;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
        },
        numerals: {
          regular: {
            "1": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
            "2": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
          },
          bold: {
            "1": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
            "2": "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
          }
        }
      },
      elevation: {
        shadow: {
          "1": "0 2px 0 0 #2323341f",
          "2": "0 4px 0 0 #2323341f",
          focusring: "0 0 0 2px #008bfaff"
        }
      },
      color: {
        brand: {
          primary: {
            "1": "#0004dbff",
            "2": "#0066ffff",
            "3": "#75c2ffff"
          },
          secondary: {
            "1": "#1cd4a8ff"
          },
          accent: {
            "1": "#ebff73ff"
          }
        },
        text: {
          content: {
            main: "#232334ff",
            auxiliary: "#6b6d7bff",
            ondark: "#ffffffff",
            primary: "#0004dbff",
            accent: "#ebff73ff"
          },
          disabled: {
            onlight: "#d3d3dfff",
            ondisabled: "#acacb9ff"
          },
          semantic: {
            error: "#db0900ff",
            success: "#148f6aff"
          }
        },
        background: {
          secondary: {
            "1": "#1cd4a8ff"
          },
          primary: {
            "1": "#e5f4ffff",
            "2": "#3b94ffff",
            "3": "#0004dbff"
          },
          accent: {
            "1": "#ebff73ff"
          },
          disabled: {
            "1": "#f5f3f9ff"
          },
          neutral: {
            "1": "#ffffffff",
            "2": "#fcfbfdff",
            "3": "#6b6d7bff",
            "4": "#474858ff"
          },
          semantic: {
            error: {
              "1": "#feb6b3ff",
              "2": "#db0900ff"
            }
          }
        },
        border: {
          enabled: "#6b6d7bff",
          active: "#0004dbff",
          error: "#db0900ff",
          warning: "#e57700ff",
          success: "#148f6aff",
          decorative: "#d3d3dfff",
          disabled: "#d3d3dfff",
          ondark: "#ffffffff",
          focusring: "#3b94ffff",
          disabledondisabled: "#acacb9ff"
        },
        iconfill: {
          ondark: "#ffffffff",
          onlight: "#232334ff",
          error: "#db0900ff",
          warning: "#e57700ff",
          success: "#148f6aff",
          disabled: "#d3d3dfff",
          ondisabled: "#acacb9ff",
          primary: "#0004dbff"
        },
        id: {
          "1": "#acacb9ff",
          "2": "#feb6b3ff",
          "3": "#ff8fd0ff",
          "4": "#d279e1ff",
          "5": "#b27df7ff",
          "6": "#addbffff",
          "7": "#75c2ffff",
          "8": "#3fecc4ff",
          "9": "#27bb8fff",
          "10": "#f0ff9eff",
          "11": "#ffde85ff",
          "12": "#f5f3f9ff"
        },
        graph: {
          "1": "#3b94ffff",
          "2": "#0004dbff",
          "3": "#e31672ff",
          "4": "#e57700ff",
          "5": "#005d5dff",
          "6": "#1f1f5bff",
          "7": "#00a3a3ff",
          "8": "#fa5b63ff",
          "9": "#8a3800ff"
        }
      },
      spacing: {
        "0": "0",
        "100": "4px",
        "200": "8px",
        "300": "12px",
        "400": "16px",
        "450": "18px",
        "600": "24px",
        "800": "32px"
      },
      size: {
        borderradius: {
          "1": "2px",
          "2": "4px",
          "3": "8px",
          "4": "12px",
          "5": "16px",
          focusring: "6px"
        },
        borderwidth: {
          thin: "1px",
          thick: "2px"
        },
        icon: {
          "1": "16px",
          "2": "20px",
          "3": "24px"
        }
      }
    },
    comp: {
      button: {
        font: {
          standard: "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;"
        },
        color: {
          background: {
            highemphasis: {
              hover: "#3b94ffff",
              pressed: "#0066ffff",
              default: "#0004dbff",
              disabled: "#f5f3f9ff"
            },
            midemphasis: {
              hover: "#e5f4ffff",
              pressed: "#addbffff"
            },
            lowemphasis: {
              hover: "#e5f4ffff",
              pressed: "#addbffff"
            },
            midemphasismonochrome: {
              hover: "#f5f3f9ff",
              pressed: "#d3d3dfff"
            }
          },
          border: {
            midemphasis: {
              default: "#0004dbff",
              disabled: "#d3d3dfff",
              hover: "#0004dbff",
              pressed: "#0004dbff"
            },
            midemphasismonochrome: {
              default: "#6b6d7bff",
              hover: "#6b6d7bff",
              pressed: "#6b6d7bff",
              disabled: "#d3d3dfff"
            }
          },
          text: {
            highemphasis: {
              default: "#ffffffff",
              hover: "#ffffffff",
              pressed: "#ffffffff",
              disabled: "#acacb9ff"
            },
            midemphasis: {
              default: "#0004dbff",
              hover: "#0004dbff",
              pressed: "#0004dbff",
              disabled: "#d3d3dfff"
            },
            lowemphasis: {
              default: "#0004dbff",
              pressed: "#0004dbff",
              hover: "#0004dbff",
              disabled: "#d3d3dfff"
            },
            midemphasismonochrome: {
              default: "#232334ff",
              hover: "#232334ff",
              pressed: "#232334ff",
              disabled: "#d3d3dfff"
            }
          },
          icon: {
            highemphasis: {
              default: "#ffffffff",
              hover: "#ffffffff",
              pressed: "#ffffffff",
              disabled: "#acacb9ff"
            },
            midemphasis: {
              default: "#0004dbff",
              hover: "#0004dbff",
              pressed: "#0004dbff",
              disabled: "#d3d3dfff"
            },
            midemphasismonochrome: {
              default: "#232334ff",
              hover: "#232334ff",
              pressed: "#232334ff",
              disabled: "#d3d3dfff"
            },
            lowemphasis: {
              default: "#0004dbff",
              hover: "#0004dbff",
              pressed: "#0004dbff",
              disabled: "#d3d3dfff"
            }
          }
        }
      },
      table: {
        cell: {
          font: {
            regular: "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 16px;text-decoration: none;",
            link: "font-family: ABC Whyte, Inter, sans-serif;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 16px;text-decoration: underline;",
            bold: "font-family: ABC Whyte, Inter, sans-serif;font-weight: 500;font-size: 14px;letter-spacing: 0.15px;line-height: 16px;text-decoration: none;"
          }
        },
        color: {
          background: {
            defaultcell: {
              selected: "#ebff73ff",
              hover: "#e5f4ffff"
            },
            totalcell: {
              selected: "#ebff73ff",
              hover: "#75c2ffff",
              default: "#addbffff"
            }
          }
        }
      },
      avatar: {
        small: {
          text: "font-family: ABC Whyte, Inter, sans-serif;font-weight: 700;font-size: 12px;letter-spacing: 0.3px;line-height: 16px;text-decoration: none;"
        }
      },
      bulkselector: {
        color: {
          background: {
            default: "#1f1f5bff",
            hover: "#d7d7f2ff",
            pressed: "#ffffffff"
          },
          border: {
            focusring: "#ffffffff"
          },
          text: {
            default: "#ffffffff",
            hover: "#1f1f5bff",
            pressed: "#1f1f5bff"
          },
          iconfill: {
            default: "#ffffffff",
            hover: "#1f1f5bff",
            pressed: "#1f1f5bff"
          }
        }
      },
      toast: {
        color: {
          background: {
            information: "#e5f4ffff",
            success: "#d9f7ecff",
            warning: "#f7f4d9ff",
            error: "#f7ddd9ff"
          },
          text: {
            link: "#0004dbff",
            warning: "#232334ff",
            information: "#232334ff",
            success: "#232334ff",
            error: "#232334ff"
          },
          border: {
            warning: "#e57700ff",
            error: "#db0900ff",
            success: "#148f6aff",
            information: "#0004dbff"
          },
          semanticicon: {
            warning: "#232334ff",
            information: "#232334ff",
            success: "#232334ff",
            error: "#232334ff"
          },
          closeicon: {
            warning: "#232334ff",
            information: "#232334ff",
            success: "#232334ff",
            error: "#232334ff"
          },
          separator: {
            warning: "#d3d3dfff",
            information: "#d3d3dfff",
            success: "#d3d3dfff",
            error: "#d3d3dfff"
          }
        }
      },
      segmentedcontrol: {
        color: {
          background: {
            default: "#f5f3f9ff",
            hover: "#d3d3dfff"
          }
        }
      },
      calendar: {
        color: {
          background: {
            calendarevent: {
              default: "#f5f3f9ff"
            }
          },
          icon: {
            iconfill: {
              disabled: "#6b6d7bff"
            }
          }
        }
      },
      placeholder: {
        background: {
          default: "#f5f3f9ff"
        },
        shimmer: {
          default: "#ffffffff"
        }
      },
      textlink: {
        color: {
          text: {
            default: "#0004dbff",
            pressed: "#1f1f5bff",
            hover: "#0004dbff"
          },
          background: {
            hover: "#e5f4ffff",
            pressed: "#e5f4ffff"
          }
        }
      },
      alerts: {
        color: {
          background: {
            information: "#e5f4ffff",
            success: "#d9f7ecff",
            warning: "#f7f4d9ff",
            error: "#f7ddd9ff"
          },
          text: {
            link: "#0004dbff",
            warning: "#232334ff",
            information: "#232334ff",
            success: "#232334ff",
            error: "#232334ff"
          },
          border: {
            warning: "#ffffff00",
            information: "#ffffff00",
            success: "#ffffff00",
            error: "#ffffff00"
          },
          semanticicon: {
            warning: "#232334ff",
            information: "#232334ff",
            success: "#232334ff",
            error: "#232334ff"
          },
          closeicon: {
            warning: "#232334ff",
            information: "#232334ff",
            success: "#232334ff",
            error: "#232334ff"
          },
          separator: {
            warning: "#d3d3dfff",
            information: "#d3d3dfff",
            success: "#d3d3dfff",
            error: "#d3d3dfff"
          },
          bar: {
            warning: "#e57700ff",
            information: "#0004dbff",
            success: "#148f6aff",
            error: "#db0900ff"
          }
        }
      }
    },
    ref: {
      color: {
        neutral: {
          "50": "#ffffffff",
          "100": "#fcfbfdff",
          "200": "#f5f3f9ff",
          "300": "#d3d3dfff",
          "400": "#acacb9ff",
          "700": "#6b6d7bff",
          "800": "#474858ff",
          "900": "#232334ff"
        },
        coolneutral: {
          "200": "#d7d7f2ff",
          "900": "#1f1f5bff"
        },
        blue: {
          "50": "#e5f4ffff",
          "100": "#addbffff",
          "200": "#75c2ffff",
          "300": "#3b94ffff",
          "500": "#0066ffff",
          "900": "#0004dbff"
        },
        mauve: {
          "200": "#d279e1ff",
          "500": "#a620a6ff"
        },
        purple: {
          "200": "#b27df7ff"
        },
        pink: {
          "300": "#ff8fd0ff"
        },
        red: {
          "50": "#f7ddd9ff",
          "100": "#feb6b3ff",
          "600": "#db0900ff"
        },
        green: {
          "50": "#d9f7ecff",
          "100": "#3fecc4ff",
          "200": "#1cd4a8ff",
          "300": "#27bb8fff",
          "700": "#148f6aff"
        },
        yellow: {
          "200": "#f0ff9eff",
          "500": "#ebff73ff"
        },
        orange: {
          "50": "#f7f4d9ff",
          "200": "#ffde85ff",
          "500": "#e57700ff",
          "900": "#8a3800ff"
        },
        teal: {
          "400": "#00a3a3ff",
          "700": "#005d5dff"
        },
        coral: {
          "400": "#fa5b63ff"
        },
        raspberry: {
          "400": "#e31672ff"
        },
        null: "#ffffff00"
      },
      unit: {
        "0": "0",
        "25": "1px",
        "50": "2px",
        "100": "4px",
        "150": "6px",
        "200": "8px",
        "300": "12px",
        "400": "16px",
        "450": "18px",
        "500": "20px",
        "600": "24px",
        "700": "28px",
        "800": "32px",
        "900": "36px",
        "1000": "40px",
        "1100": "44px",
        "1200": "48px",
        "1300": "52px",
        "1600": "64px",
        "2400": "96px"
      }
    }
  },
  sage: {
    ref: {
      color: {
        navy: {
          "15": "#fafbfbff",
          "25": "#f2f5f6ff",
          "50": "#e6ebedff",
          "75": "#d9e0e4ff",
          "100": "#ccd6dbff",
          "150": "#b3c2c9ff",
          "200": "#99adb7ff",
          "300": "#668394ff",
          "400": "#335b70ff",
          "500": "#00324cff",
          "800": "#00141eff"
        },
        yin: {
          "30": "#0000004d",
          "55": "#0000008c",
          "65": "#000000a6",
          "75": "#000000bf",
          "90": "#000000e6"
        },
        yang: {
          "0": "#ffffff00",
          "80": "#ffffffcc",
          "100": "#ffffffff"
        },
        jade: {
          "25": "#f2f9f6ff",
          "80": "#cce6daff",
          "150": "#b3d9c8ff",
          "250": "#b8f9c6ff",
          "500": "#008146ff",
          "600": "#006738ff",
          "700": "#004d2aff"
        },
        semantic: {
          disabled: {
            "100": "#f2f5f6ff",
            "200": "#e6ebedff",
            "300": "#ccd6dbff"
          },
          neutral: {
            "500": "#335b70ff",
            "600": "#00324cff"
          },
          focus: {
            "250": "#ffda80ff",
            "500": "#ffb500ff"
          },
          positive: {
            "500": "#008a21ff",
            "600": "#006e1aff"
          },
          help: {
            "500": "#00a159ff",
            "600": "#007943ff"
          },
          negative: {
            "500": "#cd384bff",
            "600": "#a42d3cff"
          },
          caution: {
            "100": "#feb6b3ff",
            "500": "#ef6700ff",
            "600": "#bf5200ff"
          },
          info: {
            "500": "#0060a7ff",
            "600": "#004d86ff"
          }
        }
      }
    },
    sys: {
      color: {
        brand: {
          primary: {
            "1": "#004d2aff",
            "2": "#006738ff",
            "3": "#008146ff"
          },
          secondary: {
            "1": "#b3d9c8ff"
          },
          accent: {
            "1": "#e6ebedff"
          }
        },
        text: {
          content: {
            main: "#000000e6",
            auxiliary: "#0000008c",
            ondark: "#ffffffff",
            primary: "#008146ff",
            accent: "#ccd6dbff"
          },
          disabled: {
            onlight: "#e6ebedff",
            ondisabled: "#ccd6dbff"
          },
          semantic: {
            error: "#cd384bff",
            success: "#006e1aff"
          }
        },
        background: {
          secondary: {
            "1": "#99adb7ff"
          },
          primary: {
            "1": "#f2f9f6ff",
            "2": "#008146ff",
            "3": "#006738ff"
          },
          accent: {
            "1": "#b3d9c8ff"
          },
          disabled: {
            "1": "#f2f5f6ff"
          },
          neutral: {
            "1": "#ffffffff",
            "2": "#fafbfbff",
            "3": "#00324cff",
            "4": "#00141eff"
          },
          semantic: {
            error: {
              "1": "#feb6b3ff",
              "2": "#cd384bff"
            }
          }
        },
        border: {
          enabled: "#335b70ff",
          active: "#008146ff",
          error: "#cd384bff",
          warning: "#ef6700ff",
          success: "#006e1aff",
          decorative: "#ccd6dbff",
          disabled: "#ccd6dbff",
          ondark: "#ffffffff",
          focusring: "#ffb500ff",
          disabledondisabled: "#99adb7ff"
        },
        iconfill: {
          ondark: "#ffffffff",
          onlight: "#00141eff",
          error: "#cd384bff",
          warning: "#ef6700ff",
          success: "#007943ff",
          disabled: "#d3d3dfff",
          ondisabled: "#acacb9ff",
          primary: "#008146ff"
        },
        id: {
          "1": "#99adb7ff",
          "2": "#feb6b3ff",
          "3": "#ff8fd0ff",
          "4": "#d279e1ff",
          "5": "#b27df7ff",
          "6": "#addbffff",
          "7": "#75c2ffff",
          "8": "#cce6daff",
          "9": "#b8f9c6ff",
          "10": "#f0ff9eff",
          "11": "#ffda80ff",
          "12": "#d9e0e4ff"
        },
        graph: {
          "1": "#008146ff",
          "2": "#004d2aff",
          "3": "#004d86ff",
          "4": "#ef6700ff",
          "5": "#335b70ff",
          "6": "#00324cff",
          "7": "#668394ff",
          "8": "#bf5200ff",
          "9": "#00141eff"
        }
      },
      spacing: {
        "0": "0",
        "100": "4px",
        "200": "8px",
        "300": "12px",
        "400": "16px",
        "450": "18px",
        "600": "24px",
        "800": "32px"
      },
      size: {
        borderradius: {
          "1": "2px",
          "2": "4px",
          "3": "8px",
          "4": "12px",
          "5": "16px",
          focusring: "6px"
        },
        borderwidth: {
          thin: "1px",
          thick: "2px"
        },
        icon: {
          "1": "16px",
          "2": "20px",
          "3": "24px"
        }
      },
      font: {
        heading: {
          "1": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 700;font-size: 32px;letter-spacing: 0;line-height: 40px;text-decoration: none;",
          "2": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 700;font-size: 28px;letter-spacing: 0;line-height: 36px;text-decoration: none;",
          "3": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 700;font-size: 24px;letter-spacing: 0;line-height: 32px;text-decoration: none;",
          "4": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 700;font-size: 20px;letter-spacing: 0;line-height: 24px;text-decoration: none;"
        },
        subheading: {
          "1": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 500;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
          "2": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 500;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
        },
        body: {
          "1": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
          "2": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
        },
        detail: {
          "1": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 12px;letter-spacing: 0.3px;line-height: 16px;text-decoration: none;",
          "2": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 10px;letter-spacing: 0.3px;line-height: 14px;text-decoration: none;"
        },
        label: {
          "1": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 500;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;"
        },
        link: {
          "1": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: underline;",
          "2": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: underline;"
        },
        tags: {
          "1": "font-family: DM Mono;font-weight: 350;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
          "2": "font-family: DM Mono;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
        },
        numerals: {
          regular: {
            "1": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
            "2": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
          },
          bold: {
            "1": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 500;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;",
            "2": "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 500;font-size: 14px;letter-spacing: 0.15px;line-height: 20px;text-decoration: none;"
          }
        }
      },
      elevation: {
        shadow: {
          "1": "0 2px 0 0 #2323341f",
          "2": "0 4px 0 0 #2323341f",
          focusring: "0 0 0 2px #008bfaff"
        }
      }
    },
    comp: {
      button: {
        color: {
          background: {
            highemphasis: {
              hover: "#006738ff",
              pressed: "#004d2aff",
              default: "#008146ff",
              disabled: "#f2f5f6ff"
            },
            midemphasis: {
              hover: "#cce6daff",
              pressed: "#b3d9c8ff"
            },
            lowemphasis: {
              hover: "#cce6daff",
              pressed: "#b3d9c8ff"
            },
            midemphasismonochrome: {
              hover: "#e6ebedff",
              pressed: "#ccd6dbff"
            }
          },
          border: {
            midemphasis: {
              default: "#008146ff",
              disabled: "#ccd6dbff",
              hover: "#006738ff",
              pressed: "#004d2aff"
            },
            midemphasismonochrome: {
              default: "#335b70ff",
              hover: "#335b70ff",
              pressed: "#335b70ff",
              disabled: "#ccd6dbff"
            }
          },
          text: {
            highemphasis: {
              default: "#ffffffff",
              hover: "#ffffffff",
              pressed: "#ffffffff",
              disabled: "#ccd6dbff"
            },
            midemphasis: {
              default: "#008146ff",
              hover: "#006738ff",
              pressed: "#004d2aff",
              disabled: "#e6ebedff"
            },
            lowemphasis: {
              default: "#008146ff",
              pressed: "#004d2aff",
              hover: "#006738ff",
              disabled: "#e6ebedff"
            },
            midemphasismonochrome: {
              default: "#000000e6",
              hover: "#000000e6",
              pressed: "#000000e6",
              disabled: "#e6ebedff"
            }
          },
          icon: {
            highemphasis: {
              default: "#ffffffff",
              hover: "#ffffffff",
              pressed: "#ffffffff",
              disabled: "#ccd6dbff"
            },
            midemphasis: {
              default: "#008146ff",
              hover: "#006738ff",
              pressed: "#004d2aff",
              disabled: "#e6ebedff"
            },
            midemphasismonochrome: {
              default: "#000000e6",
              hover: "#000000e6",
              pressed: "#000000e6",
              disabled: "#e6ebedff"
            },
            lowemphasis: {
              default: "#008146ff",
              hover: "#006738ff",
              pressed: "#004d2aff",
              disabled: "#e6ebedff"
            }
          }
        },
        font: {
          standard: "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 500;font-size: 16px;letter-spacing: 0.15px;line-height: 24px;text-decoration: none;"
        }
      },
      table: {
        color: {
          background: {
            defaultcell: {
              selected: "#b8f9c6ff",
              hover: "#f2f5f6ff"
            },
            totalcell: {
              selected: "#b8f9c6ff",
              hover: "#f2f5f6ff",
              default: "#f2f9f6ff"
            }
          }
        },
        cell: {
          font: {
            regular: "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 16px;text-decoration: none;",
            link: "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 350;font-size: 14px;letter-spacing: 0.15px;line-height: 16px;text-decoration: underline;",
            bold: "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 500;font-size: 14px;letter-spacing: 0.15px;line-height: 16px;text-decoration: none;"
          }
        }
      },
      bulkselector: {
        color: {
          background: {
            default: "#00141eff",
            hover: "#ccd6dbff",
            pressed: "#ffffffff"
          },
          border: {
            focusring: "#ffffffff"
          },
          text: {
            default: "#ffffffff",
            hover: "#000000e6",
            pressed: "#000000e6"
          },
          iconfill: {
            default: "#ffffffff",
            hover: "#000000e6",
            pressed: "#000000e6"
          }
        }
      },
      toast: {
        color: {
          background: {
            information: "#ffffffff",
            success: "#ffffffff",
            warning: "#ffffffff",
            error: "#ffffffff"
          },
          text: {
            link: "#008146ff",
            warning: "#000000e6",
            information: "#000000e6",
            success: "#000000e6",
            error: "#000000e6"
          },
          border: {
            warning: "#ef6700ff",
            error: "#cd384bff",
            success: "#007943ff",
            information: "#004d86ff"
          },
          semanticicon: {
            warning: "#ef6700ff",
            information: "#004d86ff",
            success: "#007943ff",
            error: "#cd384bff"
          },
          closeicon: {
            warning: "#00141eff",
            information: "#00141eff",
            success: "#00141eff",
            error: "#00141eff"
          },
          separator: {
            warning: "#ccd6dbff",
            information: "#ccd6dbff",
            success: "#ccd6dbff",
            error: "#ccd6dbff"
          }
        }
      },
      segmentedcontrol: {
        color: {
          background: {
            default: "#f5f3f9ff",
            hover: "#d3d3dfff"
          }
        }
      },
      calendar: {
        color: {
          background: {
            calendarevent: {
              default: "#f5f3f9ff"
            }
          },
          icon: {
            iconfill: {
              disabled: "#6b6d7bff"
            }
          }
        }
      },
      placeholder: {
        background: {
          default: "#f5f3f9ff"
        },
        shimmer: {
          default: "#ffffffff"
        }
      },
      textlink: {
        color: {
          text: {
            default: "#008146ff",
            pressed: "#004d2aff",
            hover: "#006738ff"
          },
          background: {
            hover: "#ffffff00",
            pressed: "#ffffff00"
          }
        }
      },
      alerts: {
        color: {
          background: {
            information: "#ffffffff",
            success: "#ffffffff",
            warning: "#ffffffff",
            error: "#ffffffff"
          },
          text: {
            link: "#008146ff",
            warning: "#000000e6",
            information: "#000000e6",
            success: "#000000e6",
            error: "#000000e6"
          },
          border: {
            warning: "#ef6700ff",
            information: "#004d86ff",
            success: "#007943ff",
            error: "#cd384bff"
          },
          semanticicon: {
            warning: "#ef6700ff",
            information: "#004d86ff",
            success: "#007943ff",
            error: "#cd384bff"
          },
          closeicon: {
            warning: "#00141eff",
            information: "#00141eff",
            success: "#00141eff",
            error: "#00141eff"
          },
          separator: {
            warning: "#ccd6dbff",
            information: "#ccd6dbff",
            success: "#ccd6dbff",
            error: "#ccd6dbff"
          },
          bar: {
            warning: "#ef6700ff",
            information: "#004d86ff",
            success: "#007943ff",
            error: "#cd384bff"
          }
        }
      },
      avatar: {
        small: {
          text: "font-family: Sage UI, helvetica neue, Roboto, Segoe UI, Arial;font-weight: 500;font-size: 12px;letter-spacing: 0.3px;line-height: 16px;text-decoration: none;"
        }
      }
    }
  }
};